import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { takeUntil, tap } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { IDestroy, TakeUntilDestroy } from '@utils/auto-unsubscribe';
import { Observable, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Locale } from '@shared/models/locale';
import { LangChangeEvent } from '@ngx-translate/core/lib/translate.service';
import { VersionForVisuallyImpairedRoutes } from '../../models/routes';
import { ImpairedInformationRoutes } from '../../modules/information/models/information-routes';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@TakeUntilDestroy
export class TabComponent implements OnInit, IDestroy {
  public componentDestroy: () => Subject<any>;
  public dataLink = VersionForVisuallyImpairedRoutes.DataSet;
  public appLink = VersionForVisuallyImpairedRoutes.Apps;
  public newsLink = VersionForVisuallyImpairedRoutes.News;
  public informationLink = `${VersionForVisuallyImpairedRoutes.Information}/${ImpairedInformationRoutes.AboutThePortal}`;
  public isActiveDataUrl = false;
  public isActiveAppsUrl = false;
  public isActiveNewsUrl = false;
  public isActiveInformationUrl = false;
  public isRuLocale = true;
  public langChange$: Observable<LangChangeEvent>;
  constructor(private translateService: TranslateService, private router: Router, private route: ActivatedRoute) {}
  private setAllActiveUrlToFalse(): void {
    this.isActiveDataUrl = false;
    this.isActiveAppsUrl = false;
    this.isActiveNewsUrl = false;
    this.isActiveInformationUrl = false;
  }

  private setActiveUrl(currentUrl: string): void {
    if (currentUrl.includes(VersionForVisuallyImpairedRoutes.Apps)) {
      this.isActiveAppsUrl = true;
    } else if (currentUrl.includes(VersionForVisuallyImpairedRoutes.News)) {
      this.isActiveNewsUrl = true;
    } else if (currentUrl.includes(VersionForVisuallyImpairedRoutes.Information)) {
      this.isActiveInformationUrl = true;
    } else {
      this.isActiveDataUrl = true;
    }
  }
  private setText(lang: Locale): void {
    if (lang === Locale.RU_RU) {
      this.isRuLocale = true;
    } else {
      this.isRuLocale = false;
      if (this.router.url.includes(VersionForVisuallyImpairedRoutes.Apps) || this.router.url.includes(VersionForVisuallyImpairedRoutes.News)) {
        this.router.navigate([this.dataLink], { queryParamsHandling: 'preserve', relativeTo: this.route.parent });
      }
    }
  }

  public ngOnInit(): void {
    this.setText(this.translateService.currentLang as Locale);
    this.langChange$ = this.translateService.onLangChange.pipe(
      tap(res => {
        this.setText(res.lang as Locale);
      })
    );
    this.setActiveUrl(this.router.url);
    this.router.events.pipe(takeUntil(this.componentDestroy())).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setAllActiveUrlToFalse();
        this.setActiveUrl(event.url);
      }
    });
  }
}
